import { createContext, useContext, useEffect } from 'react';

const ThemeContext = createContext(null);

// Theme is permanently locked to dark.
export const ThemeProvider = ({ children }) => {
  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove('light');
    root.classList.add('dark');
    localStorage.setItem('theme', 'dark');
  }, []);

  const noop = () => {};

  return (
    <ThemeContext.Provider value={{ theme: 'dark', setTheme: noop, toggleTheme: noop }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
